import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { compose, pure } from 'recompose'

import { connectToDoc } from '@slite/editor'
import RichTextEditor from './RichTextEditor'

class PublicNotesShowEditor extends Component {
  static propTypes = {
    noteId: PropTypes.string.isRequired,
    noteTitle: PropTypes.string,
    isEditable: PropTypes.bool.isRequired,
  }

  render() {
    const { noteId, noteTitle, isEditable, publicChannelId } = this.props
    return (
      <div key={noteId} className="position-relative">
        <RichTextEditor
          noteId={noteId}
          noteTitle={noteTitle}
          isEditable={isEditable}
          publicChannelId={publicChannelId}
        />
      </div>
    )
  }
}

export default compose(
  pure,
  connectToDoc(({ noteId }) => ({
    id: noteId,
    collection: 'notes',
  }))
)(PublicNotesShowEditor)
